import React from "react";
import altColTable from "../../images/altColTable.png";
import altRowTable from "../../images/altRowTable.png";
import normalTable from "../../images/normalTable.png";
import Input from "../FormComponents/Input";
import Label from "../FormComponents/Label";

const EditTableviewSidebar = ({ editElementData, setEditElementData }) => {
  // const handleFieldClassName = (heading, selectedValue) => {
  //   setEditElementData({ ...editElementData, className: { ...editElementData.className, [heading]: selectedValue } });
  // };

  // const handleFieldInlineStyle = (data) => {
  //   setEditElementData({ ...editElementData, inline_style: data });
  // };
  // const handleCustomCss = (e) => {
  //   const { name, value } = e.target;
  //   setEditElementData({ ...editElementData, [name]: value });
  // };
  const handleFunction = (e) => {
    setEditElementData({ ...editElementData, border: e.target.checked });
  };
  const handleHeaderFunction = (e) => {
    setEditElementData({ ...editElementData, header: e.target.checked });
  };
  const handleTableTypeFunction = (value) => {
    setEditElementData({ ...editElementData, table_type: value });
  };

  return (
    <>
      <TableStyleTypes type={editElementData.table_type || ""} onChange={handleTableTypeFunction} />
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label="Table Border"
          checked={editElementData.border}
          onChange={handleFunction}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          checked={editElementData.header}
          label="Table Header"
          onChange={handleHeaderFunction}
          containerClassName="w_50"
        />
      </div>
    </>
  );
};

export default EditTableviewSidebar;

const TableStyleTypes = ({ type, onChange }) => {
  type = type || "default";

  const typeImages = [
    {
      value: "default",
      source: normalTable,
      alt: "Normal"
    },
    {
      value: "alt_row",
      source: altRowTable,
      alt: "Alternate Row Color"
    },
    {
      value: "alt_col",
      source: altColTable,
      alt: "Alternate Column Color"
    }
  ];

  const handleTypeChange = (newType) => {
    if (onChange) onChange(newType);
  };

  return (
    <div className="builder_form">
      <Label className="builder_label">Table Type</Label>
      <div className="table_type_container">
        {typeImages.map((img) => (
          <div key={img.value} className="type_box">
            <img
              className={`type_box ${type === img.value && "selected"}`}
              src={img.source}
              alt={img.alt}
              onClick={() => handleTypeChange(img.value)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export { TableStyleTypes };
